module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-72e9362976e16abac0f55019894d9ebb.png";